import { useEffect } from "react";
import { useLocation } from "react-router";

import { useAuth } from "@/src/auth/hooks/useAuth";

export const useAuthCheckOnRouteChange = () => {
  const { pathname } = useLocation();
  const { isAuthenticated, checkAuthorization } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      checkAuthorization();
    }
  }, [pathname, isAuthenticated, checkAuthorization]);
};
